// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import parcelShopsService from './service';
import * as parcelShopsActions from './actions';
import * as types from './actionTypes';

function* parcelShopsSaga(payload) {
  const res = yield call(parcelShopsService, payload);
  if (res.ok) {
    yield put(parcelShopsActions.getParcelShopsSuccess(res.body));
  } else {
    yield put(parcelShopsActions.getParcelShopsFailed());
  }
}

const parcelShopsSagas = [
  takeEvery(types.REQUEST_PARCEL_SHOPS, parcelShopsSaga),
];

export default parcelShopsSagas;
